<div class="auth">
    <p-toast></p-toast>
    <div class="auth-content">
        <router-outlet></router-outlet>
    </div>
</div>
